// extracted by mini-css-extract-plugin
export default {"cardAuth":"Payments_cardAuth__1zaTQ","iframe":"Payments_iframe__3JKWE","show":"Payments_show__usIt5","loader":"Payments_loader__xFWUP"};